import { isWithinInterval, parse } from 'date-fns';

/**
 * Parses a string in the format `yyyy-MM-dd HH:mm` using `date-fns`.
 */
export function fromStoryblokDateTime(dateTime: string) {
  return parse(dateTime, 'yyyy-MM-dd HH:mm', new Date());
}

/**
 * Returns true if `date` is within the [start, end] range.
 * Allows for null checks on `start` or `end`.
 */
export function isDateWithinRange(date: Date, start: Date | null, end: Date | null) {
  return (
    (!start && !end) ||
    (start && !end && date >= start) ||
    (end && !start && date <= end) ||
    (start && end && isDateInRange(date, start, end))
  );
}

/**
 * Checks if a date is between two other dates (inclusive).
 */
function isDateInRange(date: Date, start: Date, end: Date) {
  return isWithinInterval(date, { start, end });
}
